import { render, staticRenderFns } from "./editVector.vue?vue&type=template&id=376ec816&scoped=true"
import script from "./editVector.vue?vue&type=script&lang=js"
export * from "./editVector.vue?vue&type=script&lang=js"
import style0 from "./editVector.vue?vue&type=style&index=0&id=376ec816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376ec816",
  null
  
)

export default component.exports